import { QINIU_PUBLIC_BASE, QINIU_UPLOAD_URL } from '../utils/domains';

/**
 * 从后端获取七牛上传 token / key / space
 * 后端接口：GET /equipment/uploadCenter/getActivityUploadGetToken
 */
async function fetchQiniuToken() {
  // 通过同源后端中转，避免浏览器跨域预检失败
  const res = await fetch('/api/sem/qiniu/token', { method: 'GET', credentials: 'include' });
  const json = await res.json();
  if (json.code !== 200 || !json.data) {
    throw new Error(json.msg || '获取上传凭证失败');
  }
  return json.data;
}


/**
 * 通用七牛上传主函数
 * @param {File|Blob} file - 要上传的文件
 * @returns {Promise<{url: string, key: string, raw: any}>}
 */
export async function uploadToQiniu(file) {
  const { key, space, token } = await fetchQiniuToken();

  const formData = new FormData();
  formData.append('file', file);
  formData.append('token', token);
  // space 可能为 "/groupact"，去掉前导斜杠再拼接，避免出现 "//groupact"
  const normalizedSpace = (space || '').replace(/^\/+/, '');
  const objectKey = normalizedSpace ? `${normalizedSpace}/${key}` : key;
  formData.append('key', objectKey);

  const uploadRes = await fetch(QINIU_UPLOAD_URL, {
    method: 'POST',
    body: formData,
  });
  const uploadJson = await uploadRes.json();

  // 统一使用我们自己拼出来的 objectKey，保证路径稳定：
  // https://pstatic.navi-sci.cn/groupact/xxxx
  const url = `${QINIU_PUBLIC_BASE.replace(/\/+$/, '')}/${objectKey.replace(/^\/+/, '')}`;

  return {
    url,
    key: objectKey,
    raw: uploadJson,
  };
}

